import React from 'react';
import {connect} from 'react-redux';
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";
import IndicatorUtils from "../../utils/IndicatorUtils";
import Spinner from "qwc2/components/widgets/Spinner";
import axios from "axios";
import isEmpty from 'lodash.isempty';
import {addLayerFeatures, LayerRole, removeLayer} from "qwc2/actions/layers";
import ConfigUtils from "qwc2/utils/ConfigUtils";
import FeatureUtils from "../../utils/FeatureUtils";
import {addForIndicators, highlightSelected, removeForIndicators} from "../../actions/indicators";

class IndicatorLinear extends React.Component {

    static propTypes = {
        addForIndicators: PropTypes.func,
        addLayerFeatures: PropTypes.func,
        compareIndicator: PropTypes.object,
        highlightSelected: PropTypes.func,
        indicators: PropTypes.array,
        removeForIndicators: PropTypes.func,
        removeLayer: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedIndicator: PropTypes.object,
        selectedObjectType: PropTypes.string,
        selectedObjects: PropTypes.array
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            objects: {},
            isLoading: true,
            url: '',
            calls: 0
        };
    }

    getIndicators() {
        const all = [];
        if (this.props.selectedIndicator) {
            all.push({
                indicator: this.props.selectedIndicator,
                time: this.props.selectedDate,
            });
        }
        if (this.props.compareIndicator) {
            all.push(this.props.compareIndicator);
        }
        return all;
    }

    getDataUrls() {
        const urls = [];
        this.getIndicators().forEach(it => {
            const url = IndicatorUtils.getDataUrl(it.indicator, this.props.selectedObjectType, it.time);
            urls.push(url);
        });
        return urls;
    }

    updateChart() {
        const urls = this.getDataUrls();
        if (urls.length > 0) {
            const self = this;

            if (this.state.url != urls.join(',')) {
                self.setState({
                    calls: urls.length,
                    url: urls.join(','),
                    objects: {}
                });
            }

            urls.forEach(url => {
                axios(url).then(response => {
                    let calls = this.state.calls;
                    const data = this.state.data;
                    const objects = {};
                    let loading = true;
                    calls--;
                    if (calls == 0) {
                        loading = false;
                    }

                    if (response.data && response.data.features) {
                        response.data.features.forEach(iv => {
                            const time = IndicatorUtils.normalizeDate(iv.properties.date);
                            const indicator = iv.properties.indicator;
                            const object = iv.properties.linkedObjectUuid;
                            objects[object] = iv;
                            if (!data[indicator]) {
                                data[indicator] = {};
                            }
                            if (!data[indicator][object]) {
                                data[indicator][object] = {};
                            }
                            if (!data[indicator][object][time]) {
                                data[indicator][object][time] = {};
                            }
                            data[indicator][object][time] = iv.properties.value;
                        });
                    }

                    self.setState({
                        data: data,
                        objects: objects,
                        calls: calls,
                        isLoading: loading
                    });
                }).catch(error => {
                    console.log("Error *** : " + error);
                });
            });
        }
    }

    componentDidMount() {
        this.updateChart();
    }

    componentDidUpdate() {
        const urls = this.getDataUrls();
        if (urls.join(',') != this.state.url) {
            this.updateChart();
        }
    }

    render() {
        if (this.getIndicators().length < 2) {
            return (
                <p style={{padding: '5px'}}>Bitte wählen Sie einen Indikator zum Vergleich aus.</p>
            );
        }
        return (
            <>
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                    </div>
                }
                {!this.state.isLoading &&
                    <>
                        {this.renderChart()}
                    </>
                }
            </>
        );
    }

    getValByIndicator(object, it) {
        const byIndicator = this.state.data[it.indicator.id];
        let val = 0;
        if (byIndicator && byIndicator[object.properties.linkedObjectUuid]) {
            val = byIndicator[object.properties.linkedObjectUuid][IndicatorUtils.normalizeDate(it.time)] || 0;
        }
        return val;
    }

    highlight = (item) => {
        if (item && item.geometry) {
            // copy, the item may belong to the redux state
            const results = [{...item, crs: 'EPSG:4326'}];
            if (!isEmpty(results)) {
                this.props.removeLayer("identifyslection");
                const layer = {
                    id: "identifyslection",
                    role: LayerRole.SELECTION
                };
                this.props.addLayerFeatures(layer, results, true);
            } else {
                this.props.removeLayer("identifyslection");
            }
        }
    }

    renderChart() {
        const that = this;
        const series = [];

        const itx = this.getIndicators()[0];
        const ity = this.getIndicators()[1];


        if (this.state.objects) {
            const selectedIds = [];
            if (this.props.selectedObjects) {
                this.props.selectedObjects.forEach(o => selectedIds.push(o.linkedObject.properties.id));
            }

            const colorRanges = IndicatorUtils.ranges(itx.indicator);
            Object.keys(this.state.objects).forEach(objectId => {
                const object = this.state.objects[objectId];
                const name = object.properties.linkedObjectName || '';

                const valx = that.getValByIndicator(object, itx);
                const valy = that.getValByIndicator(object, ity);

                const itemStyle = {
                    color: IndicatorUtils.getColor(colorRanges, valx)
                };
                if (selectedIds.indexOf(object.properties.linkedObjectUuid) > -1) {
                    itemStyle.color = '#ff0000';
                }

                series.push({
                    name: name,
                    itemStyle: itemStyle,
                    feature: object,
                    value: [valx, valy],
                });
            });
        }
        const onChartClick = (params) => {
            const data = {...params.data.feature};
            const url = ConfigUtils.getConfigProp("featureServiceUrl") + '/' + data.properties.linkedObjectType + '/items/' + data.properties.linkedObjectUuid;
            axios(url).then(response => {
                const linkedObject = FeatureUtils.getSingleFeature(response.data);
                if (linkedObject) {
                    data.linkedObject = linkedObject;

                    let isSelected = false;
                    if (this.props.selectedObjects) {
                        this.props.selectedObjects.forEach(so => {
                            if (so.properties.id == data.properties.id) {
                                isSelected = true;
                            }
                        });
                    }
                    if (isSelected) {
                        this.props.removeForIndicators(data);
                    } else {
                        this.props.addForIndicators(data);
                    }
                    this.props.highlightSelected();
                }
            }).catch(error => {
                console.log("Error *** : " + error);
            });
        };
        const onChartOver = (params) => {
            if (params.data.feature) {
                this.highlight(params.data.feature);
            }
        };
        const onEvents = {
            click: onChartClick,
            mouseover: onChartOver
        };

        const options = {
            grid: {
                left: 70,
            },
            xAxis: {
                name: itx.indicator.name + '\n' + IndicatorUtils.normalizeDate(itx.time),
                nameLocation: 'middle',
                nameGap: 35,
            },
            yAxis: {
                name: ity.indicator.name + '\n' + IndicatorUtils.normalizeDate(ity.time),
                nameLocation: 'middle',
                nameGap: 35,
            },
            tooltip: {
                trigger: 'item'
            },
            series: [
                {
                    name: '',
                    type: 'scatter',
                    colorBy: 'data',
                    data: series,
                    encode: {
                        x: 'x',
                        y: 'y',
                        tooltip: ['x', 'y']
                    },
                    dimensions: ['x', 'y'],
                }
            ]
        };
        return (
            <ReactECharts
                style={{
                    height: '100%',
                    width: '100%'
                }}
                option={options}
                notMerge={false}
                onEvents={onEvents}
                lazyUpdate={false}
                opts={{locale: 'DE'}}
            />
        );
    }
}

const selector = (state) => ({
    indicators: state.indicators.indicators,
    selectedIndicator: state.indicators.selectedIndicator,
    selectedObjects: state.indicators.selectedObjects,
    selectedObjectType: state.indicators.selectedObjectType,
    selectedDate: state.indicators.selectedDate,
    compareIndicator: state.indicators.compareIndicator,
});

export default connect(selector, {
    addLayerFeatures: addLayerFeatures,
    removeLayer: removeLayer,
    addForIndicators: addForIndicators,
    removeForIndicators: removeForIndicators,
    highlightSelected: highlightSelected,
})(IndicatorLinear);
